import React, { useContext } from "react";
import "./shared.scss";
import Page from "pages/Page";
import { Link, PageLayout, useTranslator } from "@sia/style-guide";
import SideBarWithLinks from "components/SideBarWithLinks";
import GlobalContext from "contexts/GlobalContext";

export default function InvalidSubscriptionView() {
  const { language, survey } = useContext(GlobalContext);
  const translate = useTranslator();
  const pageTitle = translate("benchmarking.evaluations.invalid-subscription.title");

  let secondParagraph = translate("benchmarking.evaluations.invalid-subscription.second-paragraph", {
    access: survey.surveyYear //survey.surveyYear === 2024
      ? translate("benchmarking.evaluations.invalid-subscription.free-access")
      : translate("benchmarking.evaluations.invalid-subscription.discount-access"),
  });

  let link = (
    <Link target={`${process.env.REACT_APP_WEB_PLATFORM_URL}/${language}/account/services`}>
      {survey.surveyYear //survey.surveyYear === 2024
        ? translate("benchmarking.evaluations.invalid-subscription.free-access-anchor-text")
        : translate("benchmarking.evaluations.invalid-subscription.discount-access-anchor-text")}
    </Link>
  );

  return (
    <Page className="landing" title={pageTitle}>
      <PageLayout variant="layout_25_50_25">
        <div></div>
        <div className="center" lang={language}>
          <h2 className="sia-text-12">{pageTitle}</h2>
          <div className="sia-text-04 sia-padding-02-bottom Localized-Text">
            {translate("benchmarking.evaluations.invalid-subscription.first-paragraph")}
          </div>
          <div className="sia-text-10 sia-padding-01-bottom Localized-Text">{secondParagraph}</div>
          {/* <div className="sia-padding-02-bottom Localized-Text">{link}</div> */}
          <div className="sia-text-10 sia-padding-01-bottom Localized-Text">
            {translate("benchmarking.evaluations.anonymous-user.third-paragraph")}
          </div>
          <div className="sia-text-10 sia-padding-01-bottom Localized-Text">
            <Link withLeadIcon type="internal" target={`${process.env.REACT_APP_WEB_PLATFORM_URL}/${language}/account/services`}>
              {translate("benchmarking.evaluations.invalid-subscription.cancel-subscription")}
            </Link>
          </div>
        </div>
        <div className={`right-column ${pageTitle.length > 39 ? "double-height-title" : ""}`}>
          <SideBarWithLinks />
        </div>
      </PageLayout>
    </Page>
  );
}
